/**
 * The package version, read from package.json at build time so the bundle, the
 * `PweChat.version` global and the `version` export can never disagree with
 * what was published. The UMD banner (vite.config.umd.ts) reads the same field;
 * widget-drift.yml compares the banner on the CDN alias against package.json on
 * main, which is how a merged-but-never-tagged release gets noticed.
 */
import { version as packageVersion } from '../package.json';

export const version: string = packageVersion;
